import { DATALAYER_NAME, GTM_ID } from '@/constants/gtm';
import { createLogger } from '@/lib/debug';
import Script from 'next/script';

const logger = createLogger('google tag manager');

export const GoogleTagManagerInitScript = (
  // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
  <Script
    id="gtm-init"
    strategy="beforeInteractive"
    dangerouslySetInnerHTML={{
      __html: `
          window['${DATALAYER_NAME}'] = window['${DATALAYER_NAME}'] || [];
          function gtag() { window['${DATALAYER_NAME}'].push(arguments); }
          
          window['${DATALAYER_NAME}'].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js',
          });
        `,
    }}
  />
);

export const GoogleTagManagerScript = (
  <Script
    id="gtm"
    src={`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`}
    strategy="afterInteractive"
    type="text/javascript"
  />
);

export const GoogleTagManagerNoScript = (
  <noscript>
    <iframe
      title="Google Tag Manager"
      src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
      height={0}
      width={0}
      style={{
        display: 'none',
        visibility: 'hidden',
      }}
    />
  </noscript>
);
